export const bridgedUSDCAddress = "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8";

export const wrappedETHAddress = "0x82af49447d8a07e3bd95bd0d56f35241523fbab1";
